import { startOfDay, endOfDay } from 'date-fns';

import { ServiceAreaModel } from './models/service-area.model';
export const License_Key = {
    AgGridLicenseKey:
        'Using_this_{AG_Grid}_Enterprise_key_{AG-066785}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{SMSAMI_Inc}_is_granted_a_{Multiple_Applications}_Developer_License_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{11_September_2025}____[v3]_[01]_MTc1NzU0NTIwMDAwMA==f1b9a6ea755835d422368b0489b45d9f',
};
export const TOASTER_MSG = {
    auth: {
        login: {
            display: 'Login successfully!',
        },
        signUp: {
            display: 'Account created successfully! Kindly check your email for user confirmation',
        },
        forgotPassword: {
            display: 'Email sent successfully!',
        },
        resetPassword: {
            display: 'Password successfully changed!',
        },
        feedback: {
            display: 'Thanks for the feedback, we will get back to you soon',
        },
        forgotPin: {
            display: 'New PIN is generated and sent on your email. Kindly check your email.',
        },
    },
    general: {
        add: {
            display: 'Added successfully!',
        },
        cancel: {
            display: 'Order has been cancelled!',
        },
        addError: {
            display: 'Server not responding at the moment.',
        },
        update: {
            display: 'Updated successfully!',
        },
        delete: {
            display: 'Deleted successfully!',
        },
        disable: {
            display: 'Disabled successfully!',
        },
        selectDeliverer: {
            display: 'Please assign a deliverer to proceed',
        },
        unableToPerformAction: {
            display: 'You are not allowed to perform this action',
        },
        cashierDisabled: {
            display: 'Your account has been disabled, please contact with admin',
        },
        addstaff: {
            display: 'Check your email for verification link',
        },
        blankErrorMessage: {
            display: 'Field cannot be blank',
        },
        deleteTaxProfile: {
            display: 'You must have at least one tax profile. This profile cannot be deleted',
        },
    },
};

export const ORG_TYPES = {
    store: {
        id: 1,
        display: 'Store',
    },
    wholeSale: {
        id: 2,
        display: 'Whole Sale',
    },
    restaurant: {
        id: 3,
        display: 'Restaurant',
    },
    pharmacy: {
        id: 4,
        display: 'Pharmacy',
    },
};
export const REGEX = {
    onlySpaces: /^\s*$/,
};

export const MEMBER_PROFILE = {
    admin: 'Admin',
    staff: 'Staff',
    public: 'Public',
};
export const ITEM_WISE_INVOICE = {
    basePrice: 'BasePrice',
    baseTaxAmount: 'BaseTaxAmount',
    appliedTaxAmount: 'AppliedTaxAmount',
    Total: 'Total',
    quantity: 'quantity',
    name: 'name',
    baseTaxRate: 'BaseTaxRate',
    orderType: 'orderType',
    appliedTaxRate: 'AppliedTaxRate',
    updatedStaff: 'UpdatedStaff',
    subtotal: 'subtotal',
    taxTotal: 'taxTotal',
    extraCharge: 'extraCharge',
    extraCharge_1: 'extraCharge_1',
    discount: 'discount',
    total: 'total',
    invoiceNumber: 'invoiceNumber',
    date: 'date',
};
export const ProfitAndLossReport = {
    Total: 'Total',
    date: 'date',
    total: 'total',
    totalItemCost: 'totalItemCost',
    grossProfit: 'grossProfit',
    totalTax: 'totalTax',
    netProfit: 'netProfit',
};

export const MAIN_MENU = {
    pos: {
        link: ['dashboard', 'pos'],
    },
    inventory: {
        link: ['dashboard', 'inventory'],
    },
    members: {
        link: ['dashboard', 'members'],
    },
    accounts: {
        link: ['dashboard', 'accounts'],
    },
};

export const USER_ROLE = {
    admin: {
        id: 1,
        display: 'admin',
    },
    operator: {
        id: 2,
        display: 'cashier',
    },
    manager: {
        id: 3,
        display: 'manager',
    },
    waiter: {
        id: 4,
        display: 'waiter',
    },
};

export const LEFT_NAVBAR_ITEMS = {
    pos: [
        {
            title: 'Sales',
            link: ['pos', 'add-sale'],
            icon: 'fa-box',
            canSee: [ORG_TYPES.store.id, ORG_TYPES.wholeSale.id],
        },
        {
            title: 'New order',
            link: ['pos', 'new-order'],
            icon: 'fa-utensils',
            canSee: [ORG_TYPES.restaurant.id, ORG_TYPES.pharmacy.id],
        },
        {
            title: 'Return',
            link: ['pos', 'return-sale'],
            icon: 'fa-exchange-alt',
            canSee: [ORG_TYPES.wholeSale.id],
        },
        {
            title: 'Transaction logs',
            link: ['pos', 'transaction-logs'],
            icon: 'fa-list',
            canSee: [ORG_TYPES.store.id, ORG_TYPES.wholeSale.id, ORG_TYPES.restaurant.id, ORG_TYPES.pharmacy.id],
            canSeeByRole: [USER_ROLE.admin.id, USER_ROLE.manager.id, USER_ROLE.operator.id],
        },
        // TODO :Hiding Profit/Loss and Category Wise Sales for now
        {
            title: 'Reports',
            canSee: [ORG_TYPES.restaurant.id, ORG_TYPES.store.id, ORG_TYPES.pharmacy.id],
            canSeeByRole: [USER_ROLE.admin.id, USER_ROLE.manager.id, USER_ROLE.operator.id],
            children: [
                {
                    title: 'Sales',
                    link: ['pos', 'sales-report'],
                    icon: 'fa-list',
                },
                {
                    title: 'Profit & Loss',
                    link: ['pos', 'profit-loss'],
                    icon: 'fa-chart-line',
                },
                {
                    title: 'Item Wise Sales',
                    link: ['pos', 'item-wise-sale-report'],
                    icon: 'fa-chart-line',
                },
                // {
                //     title: 'Category Wise Sales',
                //     link: ['pos', 'category-wise-sale-report'],
                //     icon: 'fa-chart-line',
                // },
            ],
        },
        {
            title: 'Back to main',
            link: ['../', 'main'],
            icon: 'fa-arrow-left',
            canSee: [ORG_TYPES.store.id, ORG_TYPES.wholeSale.id, ORG_TYPES.restaurant.id, ORG_TYPES.pharmacy.id],
            canSeeByRole: [USER_ROLE.admin.id, USER_ROLE.operator.id, USER_ROLE.manager.id],
        },
    ],
    inventory: [
        { title: 'Products', link: ['inventory', 'products'], icon: 'fa-box' },
        {
            title: 'Categories',
            link: ['inventory', 'categories'],
            icon: 'fa-layer-group',
        },

        {
            title: 'Deals',
            link: ['inventory', 'deals'],
            icon: 'fa-hamburger',
            canSee: [ORG_TYPES.restaurant.id],
        },
        {
            title: 'Warehouse',
            link: ['inventory', 'warehouse'],
            icon: 'fa-warehouse',
        },
        { title: 'Inventory', link: ['inventory', 'sku'], icon: 'fa-boxes' },
        {
            title: 'Vendor',
            link: ['inventory', 'vendor'],
            icon: 'fa-truck',
            canSee: [ORG_TYPES.restaurant.id, ORG_TYPES.pharmacy.id],
            canSeeByRole: [USER_ROLE.admin.id, USER_ROLE.manager.id],
        },
        {
            title: 'VendorPurchase',
            link: ['inventory', 'vendorPurchase'],
            icon: 'fa-truck',
            canSee: [ORG_TYPES.restaurant.id, ORG_TYPES.pharmacy.id],
            canSeeByRole: [USER_ROLE.admin.id, USER_ROLE.manager.id],
        },
        {
            title: 'Stock Transfer',
            link: ['inventory', 'Stock-Transfer'],
            icon: 'fa-share',
        },
        {
            title: 'SKU Mapping',
            link: ['inventory', 'SKU-Mapping'],
            icon: 'fa-warehouse',
        },

        //TODO Hidden for now it becomes stable we will show it again
        // {
        //     title: 'Process',
        //     link: ['inventory', 'process'],
        //     icon: 'fa-process',
        //     canSee: [ORG_TYPES.restaurant.id],
        //     canSeeByRole: [USER_ROLE.admin.id, USER_ROLE.manager.id],
        // },

        {
            title: 'Purchase',
            canSee: [ORG_TYPES.store.id, ORG_TYPES.wholeSale.id, ORG_TYPES.restaurant.id],
            canSeeByRole: [USER_ROLE.admin.id],
            children: [
                {
                    title: 'Add',
                    link: ['inventory', 'purchase'],
                    icon: 'fa-plus-square',
                },
                {
                    title: 'Logs',
                    link: ['inventory', 'purchase-logs'],
                    icon: 'fa-th-list',
                },
            ],
        },
        {
            title: 'Distributors',
            link: ['inventory', 'distributors'],
            icon: 'fa-truck',
            canSee: [ORG_TYPES.store.id, ORG_TYPES.wholeSale.id, ORG_TYPES.restaurant.id],
            canSeeByRole: [USER_ROLE.admin.id],
        },
        {
            title: 'Transaction History',
            link: ['inventory', 'transaction-history'],
            icon: 'fa-history',
            canSee: [ORG_TYPES.store.id, ORG_TYPES.wholeSale.id, ORG_TYPES.restaurant.id, ORG_TYPES.pharmacy.id],
            canSeeByRole: [USER_ROLE.admin.id],
        },
        {
            title: 'Audit',
            link: ['inventory', 'audit'],
            icon: 'fa-wallet',
            canSeeByRole: [USER_ROLE.admin.id, USER_ROLE.manager.id],
        },
        // TODO :Hiding Reports Section from Side NaveBar and Commented for now will uncomment if needed again
        // {
        //     // // title: 'Reports',
        //     // canSee: [
        //     //     ORG_TYPES.store.id,
        //     //     ORG_TYPES.wholeSale.id,
        //     //     ORG_TYPES.restaurant.id,
        //     //     ORG_TYPES.pharmacy.id,
        //     // ],
        //     // children: [
        //     //     {
        //     //         // title: 'Inventory Report',
        //     //         link: ['inventory', 'reports'],
        //     //         icon: 'fa-clipboard-list',
        //     //     },
        //     // ],
        // },

        {
            title: 'Back to main',
            link: ['../', 'main'],
            icon: 'fa-arrow-left',
            canSeeByRole: [USER_ROLE.admin.id, USER_ROLE.manager.id, USER_ROLE.operator.id],
        },
    ],
    members: [
        {
            title: 'My Profile',
            link: ['members', 'user-details'],
            icon: 'fa-chalkboard-teacher',
            canSee: [ORG_TYPES.store.id, ORG_TYPES.wholeSale.id, ORG_TYPES.restaurant.id, ORG_TYPES.pharmacy.id],
        },
        {
            title: 'Business Profile',
            link: ['members', 'business-profile'],
            icon: 'fa-chalkboard-teacher',
            canSee: [ORG_TYPES.store.id, ORG_TYPES.wholeSale.id, ORG_TYPES.restaurant.id, ORG_TYPES.pharmacy.id],
        },
        {
            title: 'Staff',
            link: ['members', 'view-members'],
            icon: 'fa-id-card-alt',
            canSee: [ORG_TYPES.store.id, ORG_TYPES.restaurant.id, ORG_TYPES.wholeSale.id, ORG_TYPES.pharmacy.id],
        },
        {
            title: 'Customers',
            link: ['members', 'customer'],
            icon: 'fa-users',
            canSee: [ORG_TYPES.store.id, ORG_TYPES.restaurant.id, ORG_TYPES.wholeSale.id, ORG_TYPES.pharmacy.id],
        },
        {
            title: 'Deliverer',
            link: ['members', 'deliverer'],
            icon: 'fa-biking',
            canSee: [ORG_TYPES.store.id, ORG_TYPES.restaurant.id, ORG_TYPES.wholeSale.id, ORG_TYPES.pharmacy.id],
        },
        {
            title: 'Taxes',
            link: ['members', 'taxes'],
            icon: 'fa-percent',
            canSee: [],
        },
        {
            title: 'Discounts',
            link: ['members', 'discount'],
            icon: 'fa-coins',
            canSee: [ORG_TYPES.restaurant.id, ORG_TYPES.store.id, ORG_TYPES.pharmacy.id],
        },
        {
            title: 'Vendor',
            link: ['members', 'vendor'],
            icon: 'fa-truck',
            canSee: [ORG_TYPES.restaurant.id, ORG_TYPES.pharmacy.id],
        },
        {
            title: 'Receipt',
            link: ['members', 'receipts'],
            icon: 'fa-receipt',
            canSee: [ORG_TYPES.restaurant.id],
        },
        {
            title: 'Back to main',
            link: ['../', 'main'],
            icon: 'fa-arrow-left',
            canSee: [ORG_TYPES.store.id, ORG_TYPES.wholeSale.id, ORG_TYPES.restaurant.id, ORG_TYPES.pharmacy.id],
            canSeeByRole: [USER_ROLE.admin.id, USER_ROLE.manager.id, USER_ROLE.operator.id],
        },
    ],
    accounts: [
        {
            title: 'Chart of Accounts',
            link: ['accounts', 'chart-of-accounts'],
            canSeeByRole: [USER_ROLE.admin.id, USER_ROLE.manager.id],
            icon: 'fa-book',
        },
        {
            title: 'Transaction',
            link: ['accounts', 'Transaction'],
            canSeeByRole: [USER_ROLE.admin.id, USER_ROLE.manager.id],
            icon: 'fa-exchange-alt',
        },
        {
            title: 'Back to main',
            link: ['../', 'main'],
            icon: 'fa-arrow-left',
        },
    ],
};

export const START_END_OF_DAY = {
    startOfDay: (date = new Date()) => {
        return Math.floor(startOfDay(date).getTime() / 1000);
    },
    endOfDay: (date = new Date()) => {
        return Math.floor(endOfDay(date).getTime() / 1000);
    },
};

export const TRANSACTION_LOG_TYPE = [
    {
        display: 'All',
        value: 'all',
    },
    {
        display: 'Sale',
        value: 'sale',
    },
    {
        display: 'Return',
        value: 'return',
    },
];
export const STATUS_TYPE = {
    paid: 10,
    due: 30,
    unpaid: 40,
    completed: 50,
    cancelled: 60,
    onlineUnconfirmed: 70,
    disable: 0,
};

export const RESTAURANT_LOG_TYPE = {
    completed: {
        id: STATUS_TYPE.completed,
        display: 'Completed',
    },
    unPaid: {
        id: STATUS_TYPE.unpaid,
        display: 'Unpaid',
    },
    cancelled: {
        id: STATUS_TYPE.cancelled,
        display: 'Cancelled',
    },
};

export const STORE_LOG_TYPE = {
    all: {
        id: '',
        display: 'All',
    },
    completed: {
        id: STATUS_TYPE.completed,
        display: 'Completed',
    },
    cancelled: {
        id: STATUS_TYPE.cancelled,
        display: 'Cancelled',
    },
};

export const REPORT_TYPE = {
    summary: {
        id: 1,
        display: 'Summary',
    },
    lowStock: {
        id: 2,
        display: 'Low Stock',
    },
    performance: {
        id: 3,
        display: 'Performance',
    },
    List() {
        return [REPORT_TYPE.summary, REPORT_TYPE.lowStock, REPORT_TYPE.performance];
    },
};

export const PURCHASE_LOG_TYPE = [
    {
        display: 'All',
        value: 'all',
    },
    {
        display: 'Purchase',
        value: 'purchase',
    },
    {
        display: 'Return',
        value: 'return',
    },
];

export const AUTH_ROUTES = {
    forgotPin: {
        title: 'Forgot pin',
        link: ['auth', 'forgot-pin'],
    },
    pin: {
        title: 'Pin',
        link: ['auth', 'pin'],
    },
};

export const CONFIRMATION_HEADERS_MESSAGES = {
    deleteMsg: 'Delete Entity',
    confirmation: 'Confirmation Order',
    deleteCategory: 'Delete Category',
    deleteMenu: 'Delete Menu',
    updateMenu: 'Update Menu',
    deleteProducts: 'Delete Product',
    deleteDeliverer: 'Delete Deliverer',
    deleteDiscount: 'Delete Discount',
    deleteCustomer: 'Delete Customer',
    deleteVendor: 'Delete Vendor',
    deleteStaff: 'Delete Staff',
    cancelOrder: 'Cancel Order',
    confirmOrder: 'Confirm Order',
    confirmReceipt: 'Receipt',
    navigateConfirm: 'Navigate',
    noteConfirm: 'Noted',
    updateCategory: 'Update Category',
    deleteTaxProfile: 'Delete Tax Profile',
};

export const CONFIRMATION_MESSAGES = {
    disabled: 'Are you sure to disable',
    delete: 'Are you sure to delete',
    discard: 'Are you sure to discard',
    update: 'Are you sure to update',
    cancel: 'Are you sure to cancel',
    confirm: 'Are you sure to confirm',
    onlineConfirm: 'Are you sure you want to confirm',
    receipt: 'Do you want to print receipt to',
    receiptToKitchen: 'Do you want to send receipt to',
    navigate: 'Are you sure you want to clear the items in the cart and move to the next page?',
    note: 'Updating category name will effect all the reports and history',
};
export const EMAIL_PATTERN = {
    emailRegExPattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
};
export const INVALID_ERROR_MESSAGES = {
    emailBlankError: 'Email cannot be blank',
    invalidUserName: 'Username should be an email.',
    phoneNumberBlankError: 'Phone number cannot be blank',
};

export const ITEM_TYPE = {
    item: 'category',
    standAlone: 'item',
    deal: 'deal',
};

export const ORDER_TYPES = {
    all: {
        id: 0,
        name: 'All',
    },
    dine_inn: {
        id: 1,
        name: 'DINEIN',
    },
    delivery: {
        id: 2,
        name: 'DELIVERY',
        origin: 'PHONECALL',
    },
    takeaway: {
        id: 3,
        name: 'TAKEAWAY',
    },
    foodPanda: {
        id: 5,
        name: 'FOODPANDA',
    },
    jovi: {
        id: 7,
        name: 'JOVI',
    },
};
export const RECEIPT_NOTE_TYPE = {
    dine_inn: {
        id: 1,
        name: 'dine_in',
    },
    delivery: {
        id: 2,
        name: 'delivery',
    },
    takeaway: {
        id: 3,
        name: 'take_away',
    },
    foodPanda: {
        id: 4,
        name: 'food_panda',
    },
    jovi: {
        id: 5,
        name: 'jovi',
    },
};

export const INVENTORY_TYPE = {
    inventory: 1,
    non_inventory: 0,
};

export const MIN_ACCEPT_QUANTITY = {
    quantity: 0,
};
//TODO:Will import this ORDER_METHOD const from invoice Plugin
export const ORDER_METHOD = {
    pos: {
        id: 0,
        name: 'POS',
    },
    online: {
        id: 1,
        name: 'RTM',
    },
    onlineOrderApp: {
        id: 2,
        name: 'ONLINE',
    },
};

export const ORDER_METHODS = {
    all: 'ALL',
    rtm: 'RTM',
    pos: 'POS',
};
export const ORDER_ORIGINS = {
    inperson: 'INPERSON',
    online: 'ONLINE',
    phonecall: 'PHONECALL',
    external: 'EXTERNAL',
    support: 'SUPPORT',
    originExternal: 'origin-external',
};

export const SERVICE_AREA_NAMES = [
    {
        ip: 'servicearea1.eretailpoint2.com',
        ip1: '192.168.1.142',
        name: 'Bar',
    },
    {
        ip: 'servicearea2.eretailpoint2.com',
        ip1: '192.168.1.143',
        name: 'BBQ',
    },
    {
        ip: 'servicearea3.eretailpoint2.com',
        ip1: '192.168.1.144',
        name: 'Chinese',
    },
    {
        ip: 'servicearea4.eretailpoint2.com',
        ip1: '192.168.1.145',
        name: 'Grill',
    },
    {
        ip: 'servicearea5.eretailpoint2.com',
        ip1: '192.168.1.146',
        name: 'Pizza',
    },
    {
        ip: 'servicearea6.eretailpoint2.com',
        ip1: '192.168.1.147',
        name: 'Tandoori',
    },
    {
        ip: 'servicearea7.eretailpoint2.com',
        ip1: '192.168.1.148',
        name: 'Bakery',
    },
    {
        ip: 'servicearea8.eretailpoint2.com',
        ip1: '192.168.1.149',
        name: 'Pakistani',
    },
    {
        ip: 'servicearea9.eretailpoint2.com',
        ip1: '192.168.1.150',
        name: 'English',
    },
    {
        ip: 'servicearea10.eretailpoint2.com',
        ip1: '192.168.1.151',
        name: 'Karahi',
    },
    {
        ip: 'servicearea11.eretailpoint2.com',
        ip1: '192.168.1.152',
        name: 'Desi Foods',
    },
    {
        ip: 'servicearea12.eretailpoint2.com',
        ip1: '192.168.1.153',
        name: 'Fast Food',
    },
    {
        ip: 'servicearea13.eretailpoint2.com',
        ip1: '192.168.1.154',
        name: 'Burgers',
    },
    {
        ip: 'servicearea14.eretailpoint2.com',
        ip1: '192.168.1.155',
        name: 'Italian',
    },
    {
        ip: 'servicearea15.eretailpoint2.com',
        ip1: '192.168.1.156',
        name: 'Sweets',
    },
    {
        ip: 'servicearea16.eretailpoint2.com',
        ip1: '192.168.1.157',
        name: 'Painda',
    },
    {
        ip: 'servicearea17.eretailpoint2.com',
        ip1: '192.168.1.158',
        name: 'Raita & Salads',
    },
    {
        ip: 'servicearea18.eretailpoint2.com',
        ip1: '192.168.1.159',
        name: 'Pulao',
    },
    {
        ip: 'servicearea19.eretailpoint2.com',
        ip1: '192.168.1.160',
        name: 'Chapli Kabab',
    },
];

export const PRINT_SERVER_IPS = {
    kotIp: 'kitchen.eretailpoint2.com',
    kotIp1: '192.168.1.140',
    delivererIp: 'delivery.eretailpoint2.com',
    delivererIp1: '192.168.1.141',
    proxy: 'https://192-168-0-123.eretailpoint2.com:3002',
    proxy1: 'https://192-168-1-123.eretailpoint2.com:3002',
};

export const SERVICER_AREAS = [
    'Kitchen',
    'Bar',
    'Bakery',
    'Grill',
    'BBQ',
    'Tandoori',
    'Pizza',
    'Karahi',
    'Chinese',
    'Pakistani',
    'English',
    'Desi Foods',
    'Fast Food',
    'Burgers',
    'Italian',
    'Sweets',
    'Painda',
    'Raita & Salads',
    'Pulao',
    'Chapli Kabab',
];
export const TaxPercent = {
    praItemtax: {
        value: 16.0,
    },
};

export const ORDER_TYPE = ['DINEIN', 'DELIVERY', 'TAKEAWAY', 'FOODPANDA', 'JOVI'];

export const PAYMENTS_TYPES = {
    cash: {
        id: 10,
        name: 'Cash',
    },
    credit_card: {
        id: 20,
        name: 'Credit Card',
    },
    easyPaisa: {
        id: 30,
        name: 'Easy Paisa',
    },
    jazz_Cash: {
        id: 40,
        name: 'Jazz Cash',
    },
    bank_Transfer: {
        id: 50,
        name: 'Bank Transfer',
    },
    bill_to_Company: {
        id: 60,
        name: 'Bill to Company',
    },
};
export const PAYMENT_METHOD = {
    CREDITCARD: 'CREDITCARD',
    EASYPAISA: 'EASYPAISA',
    JAZZCASH: 'JAZZCASH',
    BANKTRANSFER: 'BANKTRANSFER',
};

export const SELL_BY = {
    count: 2,
    weight: 1,
};

// Customer Form
export const CustomerFormModel = [
    'given_name',
    'resourceId',
    'company_name',
    'orgResourceId',
    'email',
    'phone_number',
    'address',
    'country_code',
];

// Deliverer Form
export const DelivererFormModel = [
    'given_name',
    'resourceId',
    'company_name',
    'email',
    'country_code',
    'phone_number',
    'roles',
    'governmentId',
    'address',
];
// Catalog Plugin
export const formModelPOS: string[] = [
    'catalogId',
    'barcode',
    'plu',
    'sell_by',
    'sell_by',
    'name',
    'variationName',
    'sort',
    'description',
    'subCategory',
    'images',
    'taxes',
    'serviceArea',
    'unit',
    'variations',
    'addons',
    'pricePerUnit',
    'metaData',
];
export const formModelDealPOS: string[] = [
    'catalogId',
    'name',
    'description',
    'images',
    'addons',
    'pricePerUnit',
    'products',
];
export const orderFormModel: string[] = [
    'organizationId',
    'vendor',
    'associatedUserId',
    'associatedMemberId',
    'associatedCustomerId',
    'associatedDelivererId',
    'orderType',
    'orderId',
    'orderNumber',
    'items',
    'extraCharge',
    'discount',
    'payments',
    'header',
    'footer',
    'metaData',
    'status',
    'customer',
    'deliverer',
    'totalAmount',
    'date',
    'serviceCharge',
    'deliveryCharge',
];

export const VendorFormModel = [
    'vendorId',
    'name',
    'phone_number',
    'governmentId',
    'company_name',
    'email',
    'address',
    'comments',
];

export const IMAGE_MESSAGE = {
    SUCCESS: 'success',
    IMAGE: 'IMAGE',
};
export const inventoryConfigurations = {
    mappinglisting: {
        orgId: '',
    },

    audit: {
        adminEditPermissions: false,
        auditBy: '',
    },
    restaurant: {
        vendor: {},
        vendorPurchase: {
            grn: true,
        },
        process: {},
        inventory: {
            adminEditPermissions: false,
        },
    },
    pharmacy: {
        vendor: {},
        vendorPurchase: {
            batchNumber: true,
            expiryDate: true,
            alignment: true,
        },
        process: {},
        inventory: {
            manufacturer: true,
            model: true,
            description: true,
            uniqueSerialNumber: true,
            adminEditPermissions: false,
        },
    },
};
export const orderDetails = {
    startTime: '',
    endTime: '',
    item: {},
    quantity: 1,
    orgTax: 0,
    orgId: '',
    items_id: '',
    sellBy: 0,
    IsRestaurant: false,
    IsPharmacy: false,
    IsServiceChargesEnable: false,
    IsDineInOrderTypeSettingBase: false,
    IsDiscountInPercentage: false,
    IsDiscountInAmount: false,
    IsDeliveryChargesEnable: false,
    IsDeliveryChargesInAmount: false,
    IsServiceChargesInAmount: false,
    IsItemTaxSettingBase: false,
    IsDiscountSettingBase: false,
    PendingLogEditRestrictionsSettingsBased: false,
    IsTaxSettingBase: false,
    IsCurrencySettingBase: '',
    IsTableNumberSettingBase: false,
    IsDiscountEnableToStaff: false,
    IsWaiter: false,
    IsDeliveryChargesInPercentage: false,
    IsDeliveryChargesFixed: false,
    IsCommentsEnable: false,
    IsKotButtonSettingBase: false,
    IsSaveButtonSettingBase: false,
    IsTableNumberRequired: false,
    IsCalculatorSettingBase: false,
    IsCreditcardTaxSettingBase: 0,
    IsJazzCashTaxSettingBase: 0,
    IsEasyPaisaTaxSettingBase: 0,
    IsBankTransferTaxSettingBase: 0,
    cartNotificationCounter: 0,
    ServiceChargesRate: 0,
    IsServiceChargesInPercentage: false,
    IsSaveReceiptSettingBase: false,
    IsPaymentTypeSettingBase: [],
    CancelOrderSettingBased: false,
    TLogReportsSettingBase: false,
    IsCommittedOrderPaymentType: false,
    DeliveryChargesRate: 0,
    origin: 'INPERSON',
    staffId: '',
    given_name: '',
    family_name: '',
    customer_data: {},
    deliverer_data: {},
    customerId: '0',
    orderType: '',
    receiptNote: '',
    origin_external: '',
    resetForm: false,
    organizationId: '',
    discount: '',
    deliveryCharges: false,
    serviceCharges: false,
    IsKotButtonInListSettingBase: false,
    isAdded: false,
    IsBeepSoundEnable: false,
    individualCartItem: false,
    supportStaffData: {},
    userId: '',
};
export const catalogBaseSettings = {
    IsCreditcardTaxSettingBase: false,
    IsCurrencySettingBase: '',
    IsScaleBasedSetting: false,
    organizationId: '',
    IsServiceAreaEnable: false,
    IsOnlineOrderSettingBase: false,
    serviceAreaList: [] as ServiceAreaModel[],
    IsItemTaxSettingBase: false,
    taxProfileListing: {},
    org: {},
};

export enum TRANSACTION_LOG_STATUS {
    ALL = 'All',
    PAID = 'PAID',
    COMMITTED = 'COMMITTED',
    DELETED = 'DELETED',
}
export enum Taxes {
    totalTax = 'Total Tax',
}
export const receiptStatus = {
    all: 'All',
    paid: 'PAID',
    committed: 'COMMITTED',
    deleted: 'DELETED',
};
export enum NOTIFICATION_CHANNEL {
    orderStatus = 'orderStatus',
    bellSoundStatus = 'bellSoundStatus',
    true = 'true',
    false = 'false',
    channel = 'track',
    orderArrive = 'orderArrive',
    storedEvents = 'storedEvent',
}

export const catalogConfig = {
    restaurant: {
        adminManagerProducts: {
            Access: true,
            restaurantlist: true,
            ServiceArea: true,
        },
        waiterCashierProducts: {
            Access: false,
            restaurantlist: true,
            ServiceArea: true,
        },
    },
};
export const accountConfig = {
    adminAccountsAccess: false,
    orgId: '',
};
export const KAPRA_NOTE = {
    NOTE: 'NOTE: SCAN THE QR CODE TO VIEW YOUR ORDER STATUS AND INVOICE. YOU CAN REQUEST A PRINTED INVOICE FROM THE BUSINESS. PLEASE REPORT ANY ISSUES TO TO THE NUMBER AT THE BOTTOM OF THIS RECEIPT.',
};
export const CASE_METHOD = {
    WALLET: 'Wallet',
    CASH: 'Cash',
    EASYPAISA: 'Easy Paisa',
    DEBIT: 'Debit',
    CHEQUE: 'Cheque',
    JAZZCASH: 'Jazz Cash',
    CREDITCARD: 'Credit Card',
    EXTERNAL: 'External',
    CHECK: 'Check',
    BANKTRANSFER: 'Bank Transfer',
    BILLTOCOMPANY: 'Bill To Company',
};
export enum RECEIPT {
    ORDER_TYPE = 'Order Type',
}
export const E_RETAIL_POINT_LINK = {
    LINK: 'https://eretailpoint.com/',
};
export interface CountryListModel {
    name: string;
    code: string;
    dialCode: string;
}
export const COUNTRY_LIST = [
    { name: 'Pak', code: 'PK', dialCode: '+92' },
    { name: 'UAE', code: 'AE', dialCode: '+971' },
];
